import { filter, type OperatorFunction } from 'rxjs';
import type { GenericLocation } from './location';

export type WithPrefix<
  State extends GenericLocation,
  Prefix extends string,
> = State extends {
  route: `${Prefix}${string}`;
}
  ? State
  : never;

export const isRouteActive = <
  Loc extends GenericLocation,
  Route extends string & Loc['route'],
>(
  location: Loc,
  route: Route
): location is WithPrefix<Loc, Route> => location.route.startsWith(route);

export const filterRouteActive = <
  Loc extends GenericLocation,
  // The `string &` part here ensures TS will infer the specific string and
  // not just the full States['route'] type
  Route extends string & Loc['route'],
>(
  route: Route
): OperatorFunction<Loc, WithPrefix<Loc, Route>> =>
  filter(state => isRouteActive(state, route));
